import moment from 'moment'

export default {

    methods: {
        datetimeFormat (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        }
    }

}
